import "./WithdrawRequest.css";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { deleteGovId } from "../../api/auth";
import Cookies from "js-cookie";
import { Snackbar, Alert } from '@mui/material';
import { setUserDetails } from "../../Redux/Slices/userDetailsSlice";
import { updateUser, getUser } from "../../api/auth";
import { useNavigate } from "react-router-dom";
import { getUserId, getToken } from "../../api/index";

function WithdrawRequest() {
    const userDetails = useSelector((state) => state.userDetails.userDetails);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [nickName, setNickName] = useState(userDetails?.displayName ? userDetails?.displayName : "N/A");
    const [isLoading, setIsLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'info'
    });

    const verificationStatus = userDetails?.governmentId?.verificationStatus;
    console.log("userDetails", userDetails);

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbar({ ...snackbar, open: false });
    };

    const showSnackbar = (message, severity) => {
        setSnackbar({
            open: true,
            message,
            severity
        });
    };

    useEffect(() => {
        const getUserDetails = async () => {
            try {
                const response = await getUser(getUserId(), getToken());
                console.log("response", response);
                dispatch(setUserDetails(response.data));
            } catch (error) {
                console.log("error", error);
            }
        }
        getUserDetails();
    }, [])

    const handleWithdrawRequest = async () => {
        try {
            console.log(userDetails.governmentId.id);
            const response = await deleteGovId(userDetails.governmentId.id, getToken());
            console.log(response);
            const updatedUserDetails = {
                ...userDetails,
                governmentId: null
            };
            dispatch(setUserDetails(updatedUserDetails));
            showSnackbar('Your request withdrawn successfully!', 'success');
        } catch (error) {
            console.log(error);
            showSnackbar('Failed to withdraw request. Please try again.', 'error');
        }
    }

    const handleUploadAgain = () => {
        navigate("/profile-details/edit-name");
    }

    const handleSubmit = async () => {
        if (!nickName.trim()) {
            showSnackbar('Nick name cannot be empty!', 'error');
            return;
        }
        setIsLoading(true);
        try {
            const data = await updateUser({
                userId: getUserId(),
                displayName: nickName,
            }, getToken());
            if (data) {
                showSnackbar('Nick name updated successfully!', 'success');
                dispatch(setUserDetails(data.userDetails));
            }
        } catch (error) {
            console.log("Error:", error);
            showSnackbar('Failed to update nick name. Please try again.', 'error');
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <div className="Feeds">
            <div className="feedsContainer">
                <div className="withdrawRequestMainContainer">
                    <div className="withdrawRequestContainer">
                        <span className="withdrawRequestText">Your Name information </span>
                        <div className="requestWithdrawProfileInfo">
                            <div className="profileInfoTitleContainer">
                                <span className="profileTitleText">First Name :</span>
                                <span className="profileTitleText">Middle Name :</span>
                                <span className="profileTitleText">Last Name :</span>
                                <span className="profileTitleText">Verification Status :</span>
                            </div>
                            <div className="profileInfoTitleContainer">
                                <span className="profileValueText">{userDetails?.firstName ? userDetails?.firstName : "N/A"}</span>
                                <span className="profileValueText">{userDetails?.middleName ? userDetails?.middleName : "N/A"}</span>
                                <span className="profileValueText">{userDetails?.lastName ? userDetails?.lastName : "N/A"}</span>
                                {verificationStatus === "Pending" && <span className="profileValueText" style={{ color: "yellow" }}>Pending</span>}
                                {verificationStatus === "approved" && <span className="profileValueText" style={{ color: "green" }}>Approved</span>}
                                {verificationStatus === "rejected" && <span className="profileValueText" style={{ color: "#C15F5F" }}>Rejected</span>}
                                {(verificationStatus === null || verificationStatus === undefined) && <span className="profileValueText" style={{ color: "#C15F5F" }}>Not uploaded</span>}
                            </div>
                        </div>
                        {verificationStatus === "Pending" && <div className="withdrawRequestBtnContainer" onClick={handleWithdrawRequest}>
                            <span className="withdrawRequestBtnText">Withdraw your request </span>
                        </div>}
                        {(verificationStatus === "rejected" || !verificationStatus) && <div className="withdrawRequestBtnContainer" onClick={handleUploadAgain}>
                            <span className="uploadAgainText">Upload </span>
                        </div>}
                    </div>
                    <div className="nickNameContainer">
                        <span className="btnText">Edit your nick name</span>
                        <div className="nameContainer">
                            <div className="nameTextContainer">
                                {/* <label className="nameText">Nick Name</label> */}
                                <input type='text' className="nameInput" placeholder="Enter your nick name" value={nickName} onChange={(e) => setNickName(e.target.value)} />
                            </div>
                            <div></div>
                        </div>
                    </div>
                    <div className="submitBtnMainContainer">
                        <div className="submitBtnContainer" style={{ width: "100%", marginBottom: "10.8vh", marginTop: "5vh" }} onClick={!isLoading ? handleSubmit : null}>
                            <button className="btnText" disabled={isLoading} style={{ opacity: isLoading ? 0.6 : 1, cursor: isLoading ? 'not-allowed' : 'pointer' }}>
                                {isLoading ? 'Updating...' : 'Update Nick Name'}
                            </button>
                        </div>
                    </div>

                </div>

                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={4000}
                    onClose={handleCloseSnackbar}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                >
                    <Alert
                        onClose={handleCloseSnackbar}
                        severity={snackbar.severity}
                        sx={{ width: '100%' }}
                    >
                        {snackbar.message}
                    </Alert>
                </Snackbar>
            </div>
        </div>
    )
}

export default WithdrawRequest;